export const objsToOpts = function (objs, idName) {
  if (!objs) {
    return []
  }
  idName = (typeof idName !== 'undefined') ? idName : 'id'
  let opts = []
  for (let i = 0; i < objs.length; i++) {
    opts.push(objs[i][idName])
  }
  return opts
}

export const optsToObjs = function (opts, idName, props) {
  idName = (typeof idName !== 'undefined') ? idName : 'id'
  let objs = []
  for (let i = 0; i < opts.length; i++) {
    let obj = { [idName]: opts[i] }
    objs.push(Object.assign(obj, props))
  }
  return objs
}

export const getObjArr = function (id) {
  return (typeof id !== 'undefined' && id !== null) ? [{ id: id }] : []
}

export const getObjID = function (arr) {
  if (Array.isArray(arr) && arr.length > 0) {
    return arr[0].id
  }
  return null
}
